
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'
import { useRoute } from 'vue-router'

// @components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

import CompleteDayRow from '@/modules/CompleteDayModule/components/CompleteDayRow/index.vue'

// @ui-kit
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewTable from '@/ui-kit/NewTable/index.vue'

// @composable
import useNotifications from '@/common/composable/useNotifications'

// @types
import { CourierReportDetails } from '@/new-services/types/couriers'

// @new-services
import couriersAPI from '@/new-services/couriers.service'

const COLUMNS = [
    {
        key: 'wave',
        name: 'Волна',
    },
    {
        key: 'routeSheet',
        name: 'Док выдача курьеру',
    },
    {
        key: 'orderNumber',
        name: 'Номер заказа',
    },
    {
        key: 'invoiceNumber',
        name: 'Номер накладной',
    },
    {
        key: 'type',
        name: 'Тип',
    },
    {
        key: 'status',
        name: 'Статус',
    },
    {
        key: 'status_lo',
        name: 'Статус ЛО',
    },
    {
        key: 'answer',
        name: 'Ответ КЦ',
    },
    {
        key: 'weight',
        name: 'Физ вес',
    },
    {
        key: 'address',
        name: 'Адрес',
    },
    {
        key: 'cash',
        name: 'Наличные',
    },
    {
        key: 'codPayment',
        name: 'Наложенный платеж',
    },
    {
        key: 'payerCompanyName',
        name: 'Плательщик',
    },
]

export default defineComponent({
    components: {
        PageTitle,
        Loader,
        NewButton,
        NewTable,
        CompleteDayRow,
    },
    setup() {
        const route = useRoute()
        const notifications = useNotifications()

        const courier_id = Number(route.params.courier_id)
        const date = route.query.date as string | null,
            date_filter = route.query.date_filter as string | null

        const state = reactive({
            is_loading: false,
            is_failed: false,
            courier: null as CourierReportDetails | null,
        })

        const loadDetails = async () => {
            if (!date) {
                notifications.notify({ type: 'danger', title: 'Параметр date обязателен' })
                return
            }

            try {
                state.is_loading = true

                const response = await couriersAPI.getCourierReportDetails(courier_id, date)
                state.courier = response.data.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении детальной информации произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadDetails)

        const pageTitle = computed(() => {
            if (state.courier) {
                return `Информация по курьеру ${state.courier.fullName} (${route.params.courier_id})`
            }

            return `Информация по курьеру (${route.params.courier_id})`
        })

        return {
            state,
            //
            loadDetails,
            //
            pageTitle,
            //
            date,
            date_filter,
            COLUMNS,
        }
    },
})
